<template>
  <section class="map" id="map-events">
    <div class="map-ui">
      <div class="map-ui-left">
      
        <div class="title-switcher only-mobile" :class="{open: switcher}">
          <div class="title-dropdown">
            <h2 class="timeline-title active" @click="switcher = !switcher">
              <p>Ивенты </p> 
              <img src="@/assets/images/icons/arrow-down.svg" width="20px" />
            </h2>
            <router-link tag="h2" class="timeline-title" :to="{name: 'places'}">Места</router-link>
          </div>
        </div>
        <h2 class="timeline-title map-city">{{ getMapCity.ru ? getMapCity.ru : getMapCity.name }} <span>{{count_events}}</span></h2>
        <div class="map-ui-group">
          <div class="input-search">
            <input 
              type="search" 
              placeholder="Поиск"
              v-model="search"
              @input="searchByTitle">
            <img src="@/assets/images/icons/search.svg" width="22px" >
            <div class="dropdown dropdown_search" v-if="$store.getters.getEvents && search.length > 2">
              <div class="dropdown-item"
                @click="openEvent(event)"
                v-for="event in $store.getters.getEvents" 
                :key="event.id">
                <div class="dropdown-item__cover" :style="{ backgroundImage: 'url(' + event.cover + ')' }"></div>
                <div class="flex-column">
                  <p class="dropdown-item__title">{{ event.title }}</p>
                  <p class="dropdown-item__place">{{ event.country }} {{ event.state }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="map-button map-button_mobile" @click="changeState('filters')">
            <img src="@/assets/images/icons/settings.svg" width="22px" >
            <p>Фильтры</p>
            <p class="map-button__filters">{{ getFilters.length }}</p>
          </div>
        </div>
      </div>
      <div class="map-ui-right">
        <!-- <div class="map-button" @click="loadByCity()">
          <p>Загрузить</p>
        </div> -->
        <div class="map-icon" @click="mapstyles = !mapstyles">
          <img src="@/assets/images/icons/edit.svg" width="22px" >
          <!-- <p>Слои</p> -->
          <div class="dropdown dropdown_search" style="width: 200px; height: 300px; right: initial; bottom: initial; left: 0; top: calc(100% + 10px);" v-if="mapstyles" @click.stop>
            <div class="dropdown-item" 
            v-for="(item, index) in customs" 
            :key="index"
            @click="setMapStyle(item)"
          >
              <div class="dropdown-item__cover" 
                :style="{ backgroundImage: 'url(' + item.cover + ')' }"
              ></div>
               <p class="dropdown-item__title">{{ item.title }}</p>
            </div>
          </div>
        </div>
        <div class="map-button where_im" @click="whereIm()">
          <img src="@/assets/images/icons/map/discovery.svg" width="22px" >
          <p>Где я?</p>
        </div>
        <div class="map-button map-button_rainbow" @click="changeState('sports')">
          <p>Виды спорта</p>
        </div>
    </div>
    </div>
    <div class="map-ui-bottom">
      <div class="map-button only-mobile" @click="backToList()">
          <img src="@/assets/images/icons/list.svg" width="22px" >
          <p>Списком {{ getEventsLength }}</p>
      </div>
      <div class="map-button map-button_action" @click="createNewEvent()">
        <p>Создать ивент</p>
      </div>
    </div>
    <LMap
      v-if="showMap"
      :zoom="getZoom"
      :center="getCenter"
      :options="mapOptions"
      @moveend="moveEnd"
      @click="setEvent"
      style="height: 100%"
      ref="myMap"
    >
      <l-tile-layer
        v-for="(layer, index) in layers"
        :key="index"
        :url="layer.url"
        :attribution="layer.attribution"
      />
      <v-marker-cluster>
        <!-- Маркер места -->
        <l-marker
          v-for="(place, index) in getGroupEvents"
          :key="index"
          :lat-lng="getPosition(place)"
          :icon="getPlaceIcon(place)"
          :opacity="getOpacityGroup(place)"
        >
          <p-popup :place="place" :events="place.markers" />
        </l-marker>

        <!-- Маркер ивента -->
        <l-marker
          v-for="event in getEvents"
          :key="event.id"
          :lat-lng="getPosition(event)"
          :icon="getIcon(event)"
          :title="event.title"
          :riseOnHover="true"
          :opacity="getOpacity(event)"
        >
          <m-popup :event="event" />
        </l-marker>

        <!-- Маркер добавления места -->
        <l-marker
          v-if="new_event"
          :lat-lng="new_event.position"
          :icon="getIconAvatar(new_event.author.avatar)"
          :title="''"
          ref="eventMarker"
        >
          <popup-create :event="new_event" @close="new_event = null" />
        </l-marker>

        <!-- Маркер пользователя -->
      </v-marker-cluster>
      <l-marker
        v-if="getLocation && getUser"
        :lat-lng="getLocation"
        :icon="getIconAvatar(getUser.avatar, 30)"
        :title="'Вы здесь'"
      >
      <title-popup 
            v-if="true" 
            v-show="true" 
            :title="'Вы здесь'"
            :zoom="getZoom" />
      </l-marker>
    </LMap>
    {{getLocation}}
  </section>
</template>

<script>
import "leaflet/dist/leaflet.css"
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { statuses } from '@/mixins.js';
import { latLng, icon } from "leaflet";
import VMarkerCluster from "vue2-leaflet-markercluster";
import MPopup from "./components/MPopup"
import PPopup from "./components/PPopup"
import PopupCreate from "./components/PopupCreate"
import sports from "./sports";
import places from "@/components/Icons/places";
import TitlePopup from "./components/TitlePopup.vue";
import state_translates from "@/data/translates/states/index.json"

export default {
  name: "MapEvents",
  data() {
    return {
      center: latLng(59.9308062, 30.3104669),
      mapstyles: false,
      customs: [
        {
          cover: require('@/assets/images/maps/jawg-sunny.jpg'),
          title: 'Jawg Sunny',
          url: "https://{s}.tile.jawg.io/jawg-sunny/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa",
        },
        {
          cover: require('@/assets/images/maps/jawg-streets.jpg'),
          title: 'Jawg Streets',
          url: 'https://{s}.tile.jawg.io/jawg-streets/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
        },
        {
          cover: require('@/assets/images/maps/jawg-light.jpg'),
          title: 'Jawg Light',
          url: 'https://{s}.tile.jawg.io/jawg-light/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
        },
        {
          cover: require('@/assets/images/maps/jawg-terrain.jpg'),
          title: 'Jawg Terrain',
          url: 'https://{s}.tile.jawg.io/jawg-terrain/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
        },
        {
          cover: require('@/assets/images/maps/jawg-dark.jpg'),
          title: 'Jawg Dark',
          url: 'https://{s}.tile.jawg.io/jawg-dark/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
        },
        {
          cover: require('@/assets/images/maps/jawg-sunny.jpg'),
          title: 'Voyager',
          url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
        },
        {
          cover: require('@/assets/images/maps/thunderforest-atlas.jpg'),
          title: 'Thunderforest Atas',
          url: 'https://{s}.tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=8007bbc787e14ff9b2152a77a7d07604',
        },
        {
          cover: require('@/assets/images/maps/thunderforest-cycle.jpg'),
          title: 'Thunderforest Cycle',
          url: 'https://{s}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=8007bbc787e14ff9b2152a77a7d07604',
        },
        {
          cover: require('@/assets/images/maps/OSM-mapnik.jpg'),
          title: 'OpenStreetMap Mapnik',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
      ],
      layers: [
        {
          url: 'https://{s}.tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=8007bbc787e14ff9b2152a77a7d07604',
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }
      ],
      attribution: '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
        tap: false
      },
      new_event: null,
      showMap: true,
      count_events: null,
      countries: [],
      country: {name: 'Россия', Iso2: 'RU'},
      // city: {name: 'Санкт-Петербург', state_code: 'SPE'},
      cities: [],
      last_center: null,
      c_a: [{
          name: 'Russian Federation',
          new: 'Russia'
      }],
      switcher: false
    };
  },
  mixins: [statuses],
  components: {
    MPopup,
    PPopup,
    PopupCreate,
    VMarkerCluster,
    LMap,
    "l-tile-layer": LTileLayer,
    'l-marker': LMarker,
    'title-popup': TitlePopup,
  },
  computed: {
    search: {
      get () {
        return this.$store.state.filters.search_events
      },
      set (value) {
        this.$store.commit('setSearchEvents', value)
      }
    },
    getLocation() {
      let location = this.$store.getters.getLocation;
      return location && !location.error
        ? {lat: location.latitude, lng: location.longitude}
        : null
    },
    getMapCity() {
      return this.$store.getters.getMapCity
    },
    getZoom() {
      return this.$store.getters.getMapZoom
    },
    getCenter() {
      let center = this.$store.getters.getMapCenter;
      return center ? latLng(center) : this.center 
    },
    getGroupEvents() {
      let markers = this.$store.getters.getEvents;
      let groups = [];
      if (markers) {
        markers.forEach((marker) => {
          if (marker.place) {
            let finded = groups.find((group) => group.id === marker.place.id);
            if (finded) {
              groups[groups.indexOf(finded)].markers.push(marker);
            } else {
              let new_place = marker.place;
              new_place.markers = [marker];
              groups.push(new_place);
            }
          }
        });
      }
      return groups;
    },
    getEvents() {
      let markers = this.$store.getters.getEvents;
      let groups = this.getGroupEvents;
      if (markers) {

        markers = markers.map((marker) => {
          let result = null;
          if (marker.place) {
            result = groups.find((group) => group.id === marker.place.id)
              ? null
              : marker;
          } else {
            result = marker.latitude && marker.longitude ? marker : null;
          }
          return result;
        });
      }
      return markers ? markers.filter((marker) => marker) : null;
    },
    getEventsLength() {
      return this.getEvents && this.getEvents.length > 0 ? `(${this.getEvents.length})` : ''
    },
    // getDestination() {
    //   return this.$store.getters.getDestination;
    // },
    getActiveEvent() {
      return this.$store.getters.getActiveEvent;
    },
    getFilteredCountries() {
      return this.countries.map(country => {
        let finded = this.c_a.find(c => c.name == country.name );
        finded ? country.name == finded.name : '';
        return country
      })
    },
    getFilters () {
        return this.$store.getters.getFilters
    },
    getUser () {
      return this.$store.getters.getAuthUser
    }
  },
  methods: {
    setMapStyle(item) {
      localStorage.setItem('mapStyle', JSON.stringify(item))
      this.layers[0].url = item.url
    },
    getMapStyle() {
      let style = localStorage.getItem('mapStyle')
      this.layers[0].url = JSON.parse(style).url
    },
    whereIm() {
      if (this.getLocation) {
        this.$refs.myMap.mapObject.flyTo({lat: this.getLocation.lat, lng: this.getLocation.lng}, 12)
      } else {
        this.$emit('getLocation')
      }
    },
    setEvent(e) {
      if (this.getUser && !this.mapstyles) {
        this.new_event = {
          title: '',
          position: e.latlng,
          author: this.getUser
        };
        this.$refs.myMap.mapObject.flyTo({lat: e.latlng.lat + 0.15, lng: e.latlng.lng}, this.getZoom)
        setTimeout(() => {
          const marker = this.$refs.eventMarker.mapObject
          if (marker) {
              marker.openPopup()
          }
        }, 100)
      }
      this.mapstyles = false
    },
    getOpacity(event) {
      let status = this.getStatus(event.date_event, event.closed_plan);
      return status === 'old' ? 0.4 : 1;
    },
    getOpacityGroup(group) {
      let result = 0.4;
      group.markers.forEach(marker => {
        let status = this.getStatus(marker.date_event, marker.closed_plan);
        result = status === 'old' ? 0.6 : 1;
      })
      return result
    },
    async openEvent(event) {
      this.$route.name === 'event' && ((this.event.id + "&" + this.event.hash) === this.$route.params.hash) 
        ? '' 
        : await this.$router.push({name: "event", params: { hash: event.id + '&' + event.hash }});
      this.$store.dispatch("changeMode", false);
    },
    // async loadByCity() {
    //   let findedCountry = this.getFilters.find(item => item.group === 'city');
    //   findedCountry ? this.getFilters.splice(this.getFilters.indexOf(findedCountry), 1) : '';
    //   this.getFilters.push({filter: this.getMapCity, group: 'city'})
    // },
    async moveEnd (data) {
      let center = data.target.getCenter();
      let position = { latitude: center.lat, longitude: center.lng }
      if (this.last_center) {
        let diff_lat = Math.abs(this.last_center.latitude - position.latitude);
        let diff_lng = Math.abs(this.last_center.longitude - position.longitude);
      if (diff_lat > 0.7 || diff_lng > 0.7) {
        let city = await this.getState(position);
        if (this.getMapCity !== city) {
          this.$store.dispatch('setMapCity', city);
          let count = await this.getCountPlaces();
          this.count_events = `(${count.data})`;
        }
        this.last_center = position
      }
      } else {
        let city = await this.getState(position);
        if (this.getMapCity !== city) {
          this.$store.dispatch('setMapCity', city);
          let count = await this.getCountPlaces();
          this.count_events = `(${count.data})`;
        }
        this.last_center = position
      }
    },
    async getState(position) {
      let state = null;
      await this.$axios.post('/api/zones/by_coords', {coords: position})
      .then(res => {
        state = {name: res.data.state, state_code: res.data.state_code}
      })
      state_translates.ru[state.name] ? state.ru = state_translates.ru[state.name] : '';
      return state 
    },
    async getCountPlaces() {
      let old_filters = this.getFilters;
      let filters = [];
      old_filters.forEach(filter => {
        filters.push(filter)
      })
      if (this.getMapCity) {
        let findedCountry = this.getFilters.find(item => item.group === 'city');
        filters = findedCountry ? filters.slice(this.getFilters.indexOf(findedCountry), 1) : filters;
        filters.push({filter: this.getMapCity, group: 'city'})
      }
  
      let params = {
        page: this.getPage, 
        filters: filters, 
        sports: this.getActiveSports,
        author: this.getUser
      };

      return await this.$axios.post('/api/events/count', params)
    },
    searchByTitle() {
      let search = this.search;
      if (search.length > 2 || search.length === 0) {
        let filters = this.getFilters;
        let finded = filters.find((filter) => filter.group === 'search');
        let filter = { filter: search, group: 'search' };
        finded ? filters.splice(filters.indexOf(finded), 1) : '';
        filters.push(filter);
        this.$store.dispatch('setFilters', filters);
      }
    },
    createNewEvent() {
      this.$store.dispatch('setNewType', 'events');
      this.$store.dispatch('changeState', {element: 'workplace'});
    },
    changeState(element) {
      this.$store.dispatch('changeState', { element: element, val: true });
    },

    backToList() {
      this.$router.push("/events");
      this.$store.dispatch("changeList", true);
    },
    getPosition(event) {
      return event.place
        ? latLng(event.place.latitude, event.place.longitude)
        : latLng(event.latitude, event.longitude);
    },
    getIcon(event) {
      let sport =
        event.sports.length > 0
          ? event.sports.length > 1
            ? sports.mix
            : sports[event.sports[0].name]
              ? sports[event.sports[0].name]
              : sports.none
          : sports.none;
      var template = [sport()].join("\n");
      let icon_ready =
        "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(template);
        
      return event.sports.length == 0 || !sports[event.sports[0].name]
        ? this.getIconAvatar(event.author.avatar)
        : icon({
            iconUrl: icon_ready,
            iconSize: [40, 40],
            iconAnchor: [20, 20]
          });
    },
    getPlaceIcon(place) {
      let ic = place.icon ? places[place.icon] : places.flag;
      var template = [ic('#2d2c3a')].join("\n");
      let icon_ready = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(template);
      return icon({
        iconUrl: icon_ready,
        iconSize: [40, 40],
        iconAnchor: [20, 20]
      });
    },
    getIconAvatar(avatar, size) {
      size = !size ? 40 : size
      return icon({
        iconUrl: avatar,
        iconSize: [size, size],
        iconAnchor: [20, 20]
      });
    },
   async setCenter (active) {
     if (active && active.place) {
        this.$store.dispatch('setCenter', latLng(active.place.latitude, active.place.longitude));
      } else if (
        active &&
        active.latitude &&
        active.longitude
      ) {
        this.$store.dispatch('setCenter', latLng(active.latitude, active.longitude));
      }
   }
    

  },
  watch: {
    getActiveEvent: 'setCenter',
    // getDestination(destination) {
    //   let map = this.$refs.myMap.mapObject;
    //   L.Routing.control({
    //     waypoints: [
    //       L.latLng(destination.destination),
    //       L.latLng(destination.origin),
    //     ],
    //     lineOptions: {
    //       styles: [{ color: "#53cbb5", opacity: 1, weight: 5 }],
    //     },
    //     createMarker: (i, waypoint, n) => {
    //       let marker = null;
    //       if (i === n - 1) {
    //         marker = L.marker(waypoint.latLng, {
    //           draggable: false,
    //           bounceOnAdd: false,
    //           icon: this.getIconAvatar(),
    //         });
    //       }
    //       return marker;
    //     },
    //     router: new L.Routing.GraphHopper(
    //       "701eb64c-4e99-4e23-a53b-ddf04ec94e17",
    //       {
    //         urlParameters: {
    //           vehicle: this.$store.getters.getTravelMode,
    //           locale: 'ru'
    //         },
    //       }
    //     ),
    //     showAlternatives: true,
    //   }).addTo(map);
    // }
  },
  async mounted () {
    this.getActiveEvent ? this.setCenter(this.getActiveEvent) : '';
  },
  created () {
    this.getMapStyle()
  } 
};
</script>